function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import isMuiElement from '@mui/utils/isMuiElement';
import generateUtilityClass from '@mui/utils/generateUtilityClass';
import composeClasses from '@mui/utils/composeClasses';
import systemStyled from "../styled/index.js";
import useThemePropsSystem from "../useThemeProps/index.js";
import useThemeSystem from "../useTheme/index.js";
import { extendSxProp } from "../styleFunctionSx/index.js";
import createTheme from "../createTheme/index.js";
import { generateGridStyles, generateGridSizeStyles, generateGridColumnsStyles, generateGridColumnSpacingStyles, generateGridRowSpacingStyles, generateGridDirectionStyles, generateGridOffsetStyles, generateSizeClassNames, generateSpacingClassNames, generateDirectionClasses } from "./gridGenerator.js";
import deleteLegacyGridProps from "./deleteLegacyGridProps.js";
import { jsx as _jsx } from "react/jsx-runtime";
var defaultTheme = createTheme();
// widening Theme to any so that the consumer can own the theme structure.
var defaultCreateStyledComponent = systemStyled('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        return styles.root;
    }
});
function useThemePropsDefault(props) {
    return useThemePropsSystem({
        props: props,
        name: 'MuiGrid',
        defaultTheme: defaultTheme
    });
}
export default function createGrid() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_createStyledComponent = options.// This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent, createStyledComponent = _options_createStyledComponent === void 0 ? defaultCreateStyledComponent : _options_createStyledComponent, _options_useThemeProps = options.useThemeProps, useThemeProps = _options_useThemeProps === void 0 ? useThemePropsDefault : _options_useThemeProps, _options_useTheme = options.useTheme, useTheme = _options_useTheme === void 0 ? useThemeSystem : _options_useTheme, _options_componentName = options.componentName, componentName = _options_componentName === void 0 ? 'MuiGrid' : _options_componentName;
    var useUtilityClasses = function(ownerState, theme) {
        var container = ownerState.container, direction = ownerState.direction, spacing = ownerState.spacing, wrap = ownerState.wrap, size = ownerState.size;
        var slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && "wrap-xs-".concat(String(wrap))
            ].concat(_to_consumable_array(generateDirectionClasses(direction)), _to_consumable_array(generateSizeClassNames(size)), _to_consumable_array(container ? generateSpacingClassNames(spacing, theme.breakpoints.keys[0]) : []))
        };
        return composeClasses(slots, function(slot) {
            return generateUtilityClass(componentName, slot);
        }, {});
    };
    function parseResponsiveProp(propValue, breakpoints) {
        var shouldUseValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
            return true;
        };
        var parsedProp = {};
        if (propValue === null) {
            return parsedProp;
        }
        if (Array.isArray(propValue)) {
            propValue.forEach(function(value, index) {
                if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) {
                    parsedProp[breakpoints.keys[index]] = value;
                }
            });
        } else if ((typeof propValue === "undefined" ? "undefined" : _type_of(propValue)) === 'object') {
            Object.keys(propValue).forEach(function(key) {
                var value = propValue[key];
                if (value !== null && value !== undefined && shouldUseValue(value)) {
                    parsedProp[key] = value;
                }
            });
        } else {
            parsedProp[breakpoints.keys[0]] = propValue;
        }
        return parsedProp;
    }
    var GridRoot = createStyledComponent(generateGridColumnsStyles, generateGridColumnSpacingStyles, generateGridRowSpacingStyles, generateGridSizeStyles, generateGridDirectionStyles, generateGridStyles, generateGridOffsetStyles);
    var Grid = /*#__PURE__*/ React.forwardRef(function Grid(inProps, ref) {
        var theme = useTheme();
        var themeProps = useThemeProps(inProps);
        var props = extendSxProp(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        deleteLegacyGridProps(props, theme.breakpoints);
        var className = props.className, children = props.children, tmp = props.columns, columnsProp = tmp === void 0 ? 12 : tmp, _props_container = props.container, container = _props_container === void 0 ? false : _props_container, _props_component = props.component, component = _props_component === void 0 ? 'div' : _props_component, _props_direction = props.direction, direction = _props_direction === void 0 ? 'row' : _props_direction, _props_wrap = props.wrap, wrap = _props_wrap === void 0 ? 'wrap' : _props_wrap, tmp1 = props.size, sizeProp = tmp1 === void 0 ? {} : tmp1, tmp2 = props.offset, offsetProp = tmp2 === void 0 ? {} : tmp2, tmp3 = props.spacing, spacingProp = tmp3 === void 0 ? 0 : tmp3, tmp4 = props.rowSpacing, rowSpacingProp = tmp4 === void 0 ? spacingProp : tmp4, tmp5 = props.columnSpacing, columnSpacingProp = tmp5 === void 0 ? spacingProp : tmp5, tmp6 = props.unstable_level, level = tmp6 === void 0 ? 0 : tmp6, other = _object_without_properties(props, [
            "className",
            "children",
            "columns",
            "container",
            "component",
            "direction",
            "wrap",
            "size",
            "offset",
            "spacing",
            "rowSpacing",
            "columnSpacing",
            "unstable_level"
        ]);
        var size = parseResponsiveProp(sizeProp, theme.breakpoints, function(val) {
            return val !== false;
        });
        var offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        var _inProps_columns;
        var columns = (_inProps_columns = inProps.columns) !== null && _inProps_columns !== void 0 ? _inProps_columns : level ? undefined : columnsProp;
        var _inProps_spacing;
        var spacing = (_inProps_spacing = inProps.spacing) !== null && _inProps_spacing !== void 0 ? _inProps_spacing : level ? undefined : spacingProp;
        var _inProps_rowSpacing, _ref;
        var rowSpacing = (_ref = (_inProps_rowSpacing = inProps.rowSpacing) !== null && _inProps_rowSpacing !== void 0 ? _inProps_rowSpacing : inProps.spacing) !== null && _ref !== void 0 ? _ref : level ? undefined : rowSpacingProp;
        var _inProps_columnSpacing, _ref1;
        var columnSpacing = (_ref1 = (_inProps_columnSpacing = inProps.columnSpacing) !== null && _inProps_columnSpacing !== void 0 ? _inProps_columnSpacing : inProps.spacing) !== null && _ref1 !== void 0 ? _ref1 : level ? undefined : columnSpacingProp;
        var ownerState = _object_spread_props(_object_spread({}, props), {
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        });
        var classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ _jsx(GridRoot, _object_spread_props(_object_spread({
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: clsx(classes.root, className)
        }, other), {
            children: React.Children.map(children, function(child) {
                if (/*#__PURE__*/ React.isValidElement(child) && isMuiElement(child, [
                    'Grid'
                ]) && container && child.props.container) {
                    var _child_props;
                    var _child_props_unstable_level;
                    return /*#__PURE__*/ React.cloneElement(child, {
                        unstable_level: (_child_props_unstable_level = (_child_props = child.props) === null || _child_props === void 0 ? void 0 : _child_props.unstable_level) !== null && _child_props_unstable_level !== void 0 ? _child_props_unstable_level : level + 1
                    });
                }
                return child;
            })
        }));
    });
    process.env.NODE_ENV !== "production" ? Grid.propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        columns: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.number),
            PropTypes.number,
            PropTypes.object
        ]),
        columnSpacing: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.string
            ])),
            PropTypes.number,
            PropTypes.object,
            PropTypes.string
        ]),
        component: PropTypes.elementType,
        container: PropTypes.bool,
        direction: PropTypes.oneOfType([
            PropTypes.oneOf([
                'column-reverse',
                'column',
                'row-reverse',
                'row'
            ]),
            PropTypes.arrayOf(PropTypes.oneOf([
                'column-reverse',
                'column',
                'row-reverse',
                'row'
            ])),
            PropTypes.object
        ]),
        offset: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.arrayOf(PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ])),
            PropTypes.object
        ]),
        rowSpacing: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.string
            ])),
            PropTypes.number,
            PropTypes.object,
            PropTypes.string
        ]),
        size: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.bool,
            PropTypes.number,
            PropTypes.arrayOf(PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.bool,
                PropTypes.number
            ])),
            PropTypes.object
        ]),
        spacing: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.oneOfType([
                PropTypes.number,
                PropTypes.string
            ])),
            PropTypes.number,
            PropTypes.object,
            PropTypes.string
        ]),
        sx: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.oneOfType([
                PropTypes.func,
                PropTypes.object,
                PropTypes.bool
            ])),
            PropTypes.func,
            PropTypes.object
        ]),
        wrap: PropTypes.oneOf([
            'nowrap',
            'wrap-reverse',
            'wrap'
        ])
    } : void 0;
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}
